import { Capabilities } from './Capabilities';
import { addUserSelectClass, removeUserSelectClass } from './userSelect';
const DragStyleNodeId = 'active-drag--styles';
const DragClassName = 'drag---active';
const getActiveDragStyle = (name) => `
.${name} {
    cursor: pointer!important;
}`;
function addActiveDragStyleTag() {
    if (document.getElementById(DragStyleNodeId)) {
        return;
    }
    const styleNode = document.createElement('style');
    styleNode.setAttribute('id', DragStyleNodeId);
    styleNode.innerHTML = getActiveDragStyle(DragClassName);
    document.body.append(styleNode);
}
export function addActiveDragClass() {
    addActiveDragStyleTag();
    addUserSelectClass();
    if (!isDragClassPresent()) {
        document.body.classList.add(DragClassName);
    }
}
export function removeActiveDragClass() {
    removeUserSelectClass();
    if (isDragClassPresent()) {
        document.body.classList.remove(DragClassName);
    }
}
export function isDragClassPresent() {
    return document.body.classList.contains(DragClassName);
}
export const getSingleFileItem = (data) => {
    let index = 0;
    const { items } = data;
    while (index < items.length) {
        const item = items[index];
        index += 1;
        if (item.kind === 'file') {
            return item;
        }
    }
    return null;
};
export const itemContainsPlainText = (item) => item.type.startsWith('text/plain');
export const itemContainsImage = (item) => item.type.startsWith('image/');
export const shouldPromptUserIfPastingScreenshot = (source) => {
    var _a;
    return source.type === 'image/png' &&
        Capabilities.shared.isMac &&
        ((_a = window.devicePixelRatio) !== null && _a !== void 0 ? _a : 1) !== 1;
};
